export default __webpack_public_path__ + "static/media/CountPage1.84ce03d1.txt";